import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { toast } from "sonner";
import { Loader2, Leaf } from "lucide-react";

const AdminLogin = () => {
  const { login, admin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (admin) navigate("/admin", { replace: true }); }, [admin, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-forest-deep px-6">
      <div className="w-full max-w-md bg-bone p-10 md:p-12">
        <div className="flex items-center gap-3 mb-2">
          <Leaf className="text-forest" size={26} strokeWidth={1.5} />
          <span className="font-serif text-2xl text-ink">Fresh Landscape</span>
        </div>
        <p className="overline mb-8">Admin Portal</p>
        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <label className="fl-label">Email</label>
            <input data-testid="admin-email" type="email" className="fl-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" />
          </div>
          <div>
            <label className="fl-label">Password</label>
            <input data-testid="admin-password" type="password" className="fl-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <button data-testid="admin-login-submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">
            {loading && <Loader2 className="animate-spin mr-2" size={18} />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
